<li
  [cdxTrackImpression]="impressionArgs"
  [trackingBehaviour]="impressionTrackingBehaviour"
  [preventFallbackImpression]="true">
  <ng-content></ng-content>
</li>